import React, { useRef, useEffect, useState } from 'react';
import { Box, TextField } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledTextField = styled(TextField)(({ theme }) => ({
    '& .MuiOutlinedInput-root': {
        width: '40px',
        height: '40px',
        margin: '0 4px',
        textAlign: 'center',
        '& input': {
            padding: '0',
            textAlign: 'center',
            fontSize: '1.2rem',
        },
    },
}));

const OTPInput = ({ length = 6, value, onChange, error, disabled, autoFocus = true }) => {
    const [otp, setOtp] = useState(Array(length).fill(''));
    const inputRefs = useRef([]);

    useEffect(() => {
        if (value) {
            setOtp(value.split(''));
        }
    }, [value]);

    const handleChange = (index, value) => {
        if (value.length > 1) {
            // Handle paste
            const pastedValue = value.slice(0, length);
            const newOtp = [...otp];
            pastedValue.split('').forEach((char, i) => {
                if (i < length) newOtp[i] = char;
            });
            setOtp(newOtp);
            onChange(newOtp.join(''));
            return;
        }

        const newOtp = [...otp];
        newOtp[index] = value;
        setOtp(newOtp);
        onChange(newOtp.join(''));

        // Auto-focus next input
        if (value && index < length - 1) {
            inputRefs.current[index + 1].focus();
        }
    };

    const handleKeyDown = (index, e) => {
        if (e.key === 'Backspace' && !otp[index] && index > 0) {
            inputRefs.current[index - 1].focus();
        }
    };

    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                gap: 1,
                my: 2,
            }}
            role="group"
            aria-label="OTP input"
        >
            {Array(length).fill('').map((_, index) => (
                <StyledTextField
                    key={index}
                    inputRef={el => inputRefs.current[index] = el}
                    value={otp[index]}
                    onChange={e => handleChange(index, e.target.value)}
                    onKeyDown={e => handleKeyDown(index, e)}
                    error={error}
                    disabled={disabled}
                    autoFocus={autoFocus && index === 0}
                    inputProps={{
                        maxLength: 1,
                        pattern: '[0-9]*',
                        inputMode: 'numeric',
                        'aria-label': `OTP digit ${index + 1}`,
                    }}
                />
            ))}
        </Box>
    );
};

export default OTPInput; 